// biome-ignore-all lint/performance/noJsxPropsBind: pre-existing, outside the ADS color pairing in ENG-1520
import { memo } from 'react';

import { type Color } from '@air/api/types';
import { Checkbox } from '@air/primitive-checkbox';

import { type ColorToggleParams } from './ColorFilterCard';

export type ColorFilterProps = {
  colors: Color[];
  onClick: (params: ColorToggleParams) => void;
  selectedColors: string[];
};

export const ColorFilter = memo(({ colors, onClick, selectedColors }: ColorFilterProps) => {
  return (
    <div className="flex flex-wrap gap-1">
      {colors.map((color) => (
        <Checkbox
          className={
            color.name === 'white'
              ? 'radix-state-checked:ads:border-ads-gray-8 radix-state-checked:border-gray-8 radix-state-checked:text-black'
              : 'border-none'
          }
          style={{ backgroundColor: color.hex }}
          data-testid="COLOR_FILTER_CHECKBOX"
          data-color-name={color.name}
          key={color.hex}
          checked={selectedColors.includes(color.hex)}
          onCheckedChange={(checked) => onClick({ color, isSelected: !!checked })}
          size="large"
        />
      ))}
    </div>
  );
});

ColorFilter.displayName = 'ColorFilter';
